export function isFindShortcut(event) {
  return (event.ctrlKey || event.metaKey) &&
    !event.altKey &&
    !event.shiftKey &&
    event.key.toLowerCase() === "f";
}

export function focusSearchForShortcut(event, input) {
  if (!isFindShortcut(event)) return false;

  event.preventDefault();
  input.focus();
  input.select();
  return true;
}

function escapeRegExp(value) {
  return value.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}

// Builds a global, case-insensitive matcher for the trimmed query, or null when there is
// nothing meaningful to highlight. Mirrors the server-side ILIKE substring search.
export function buildHighlightRegex(query) {
  const trimmed = (query || "").trim();
  if (!trimmed) return null;

  return new RegExp(escapeRegExp(trimmed), "gi");
}

// Splits a text string into ordered segments, marking which ones matched the query. Returns a
// single unmatched segment when the query is blank or absent so callers can treat every text node
// uniformly. Pure (no DOM) so it is unit-testable on its own.
export function splitTextForHighlight(text, query) {
  const source = text || "";
  const regex = buildHighlightRegex(query);
  if (!regex || source === "") return [{ text: source, match: false }];

  const segments = [];
  let lastIndex = 0;
  let result;
  while ((result = regex.exec(source)) !== null) {
    if (result.index > lastIndex) {
      segments.push({ text: source.slice(lastIndex, result.index), match: false });
    }
    segments.push({ text: result[0], match: true });
    lastIndex = result.index + result[0].length;

    // Guard against zero-length matches looping forever (defensive; query is non-empty here).
    if (result[0].length === 0) regex.lastIndex += 1;
  }

  if (lastIndex < source.length) {
    segments.push({ text: source.slice(lastIndex), match: false });
  }

  return segments;
}
